<template>
  <div>
  <el-dialog append-to-body :title="title" :visible.sync="dialogFormVisible" style="width:1200px;margin:auto;" @close="close" :close-on-click-modal="false">
      <el-row class="QueryForm">
        <div class="el-col el-col-6">
          <div class="el-form-item">
            <label class="el-form-item__label">姓名</label>
            <div class="el-form-item__content">
              <input type="text" v-model="queryForm.Name">
            </div>
          </div>
        </div>    
        <div class="el-col el-col-12">
          <div class="el-form-item">
            <label class="el-form-item__label">省/市/区</label>
            <div class="el-form-item__content">
              <select v-model="queryForm.Province" placeholder="请选择省份"  @change="changeProvince(queryForm.Province)" >
                <option v-for="item in provinces" :key="item.value" :label="item.name" :value="item.name" />
              </select>
              <select v-model="queryForm.City" placeholder="请选择城市"  @change="changeCity(queryForm.City)" >
               <option v-for="item in cities" :key="item.value" :label="item.name" :value="item.name" />
              </select>
              <select v-model="queryForm.Area" placeholder="请选择县/区" >
               <option v-for="item in areas" :key="item.value" :label="item.name" :value="item.name" />
              </select>
            </div>
          </div>
        </div>   
        <el-col :span="2" >
          <el-button type="primary" @click="_getAllVeterans">搜索</el-button>
        </el-col>
      </el-row>
      <div class="selectVeteran" v-loading="loading" :element-loading-text="elementLoadingText">
        <el-row>
          <el-col class="veteranCol" :span="4" v-for="(item,i) in list" :key="i" >
            <div class="veteranChecked"><el-checkbox v-model="item.checked" @change="selectVeteran(item.id)" :key="'select_'+item.id" ></el-checkbox> </div>
            <div class="veteranPhoto"  @click="selectVeteran(item.id)" title="双击查看详情" @dblclick.prevent="seeDetail(item)">
              <img class="photo" :src="item.photo" />
              <img v-if="item.sex==0||item.sex==false" class="sex" src="https://file-sz.fjjykj.com.cn/Supply/s6e13598728334b924712b04a842b4eef.png" />
              <img v-else class="sex" src="https://file-sz.fjjykj.com.cn/Supply/sd2ffec0974c7f31c402e31a89c6e4d8b.png" />
            </div>
            <div class="veteranName" title="双击查看详情"  @dblclick.prevent="seeDetail(item)" @click="selectVeteran(item.id)">{{item.name}}<span>{{item.age}}岁</span></div>
          </el-col>         
        </el-row>            
      </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
   
  </el-dialog>
  <veteranDetail ref="veteranDetail"></veteranDetail>
</div>
</template>
<style>
@import '../../../styles/selectVeteran.css';
</style>
<script>
import { getVeterans} from '@/api/order'
import { getAreas} from '@/api/commonLookup' 
import VeteranDetail from './VeteranDetail' 
export default {
  name: 'selectVeteran',
  components: { VeteranDetail },
  data() {
    return {
      list:[],     
      veteranId:0, 
      veteranName:'',
      sex:false,
      photo:'',
      title: '',
      elementLoadingText: '数据加载中，请稍后...',     
      loading:false,
      dialogFormVisible: false,
      currentPage: 1,
      total: 0,
      pageSize: 24,
      queryForm:{
        Name:'',
        Province:'',
        City:'',
        Area:''
      },
      provinces: [],
      cities: [],
      areas: [],
    }
  },
  created() {   
    getAreas({id:null}).then((response) => {      
          this.provinces = response.data.result.items
        })
  },
  methods: {
    async showSelect(row) {
      this.title = '帮扶人员（选择一人）'   
      this.queryForm.Province = row.province;
      this.queryForm.City = row.city;
      this.queryForm.Area = row.area;
      debugger;
      this._getAllVeterans();
      this.changeProvinceAndCity(row.province,row.city);
      this.dialogFormVisible = true
    },   
    seeDetail(row)
    {
     
      this.$refs['veteranDetail'].show({id:row.id,name:row.name}) 
      //this.dialogFormVisible = false;
    },
    selectVeteran(id)
      {             
        this.veteranId=id;
         for(var i=0;i<this.list.length;i++)
         {          
            if(this.list[i].id!=id)
            {             
              this.list[i].checked = false;
            }
            else
            {              
              this.veteranId=id;
              this.veteranName = this.list[i].name;
              this.sex = this.list[i].sex;
              this.photo = this.list[i].photo;
              this.list[i].checked = true;
            }
         }
      },     
    async _getAllVeterans()
    {
      this.loading=true;
        var result = await getVeterans(this.queryForm);    
        this.list = [];
        var tempList = result.data.result.items;
        if(tempList&&tempList.length>0)
        {
          tempList.forEach(x => {
            this.list.push({
                  id:x.id,
                  name:x.name,
                  serviceStationName:x.serviceStationName,
                  mobile:x.mobile,
                  photo:x.photo,
                  age:x.age,
                  sex:x.sex,
                  checked:false
            });  
          });                   
        }
        this.total = result.data.result.totalCount;
        this.loading=false;
    },
    async changeProvinceAndCity(province, city) {
      debugger;
        let item = this.provinces.find((p) => p.name == province)
        if (item) {     
        getAreas({ id: item.value }).then((res) => {   
            this.cities = res.data.result.items
            var item1 = this.cities.find((p) => p.name == city)
            if(item1)
            {
              getAreas({ id: item1.value }).then((res1) => {      
                 this.areas = res1.data.result.items
              })     
            }
          })        
        } else {
          this.cities = []
        }      
    },
      async changeProvince(province) {
        let item = this.provinces.find((p) => p.name == province)
        if (item) {     
        getAreas({ id: item.value }).then((res) => {   
            this.cities = res.data.result.items
          })        
        } else {
          this.cities = []
        }
        this.areas = []
        this.queryForm.City = undefined
        this.queryForm.Area = undefined
    },   
    async changeCity(city) {
        let item = this.cities.find((p) => p.name == city)
        if (item) {
          getAreas({ id: item.value }).then((res) => {      
            this.areas = res.data.result.items
          })           
        } else {
          this.areas = []
        }
        this.queryForm.Area = undefined
    },
    close() {
      this.dialogFormVisible = false
    },
    save(){
        if(this.veteranId<=0||this.veteranId==undefined||this.veteranId==null)
        {
          this.$message({ message: '请选择帮扶对象', type: 'error', customClass: 'c-msg' }) 
          return;
        }     
        this.$emit('seted', { veteranId:this.veteranId,veteranName:this.veteranName,sex:this.sex,photo:this.photo });
        this.close()
      },
  },
}
</script>



// WEBPACK FOOTER //
// SelectVeteran.vue?33d001d1